import { render, staticRenderFns } from "./invoiceList.vue?vue&type=template&id=b83bfb3a"
import script from "./invoiceList.vue?vue&type=script&lang=js"
export * from "./invoiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports